// removed by extract-text-webpack-plugin
module.exports = {"supportMessage":"_3E0NrnKKF53cX8XfJFHVK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResendLimitExceededMessage/ResendLimitExceededMessage.scss
// module id = 1777
// module chunks = 0